$(document).ready(function () {
  $(".apps-prev-button").click(function () {
    let parent = ".product-media-modal__content";
    $(parent)
      .find(".img-fluid")
      .each(function () {
        if ($(this).hasClass("active")) {
          let count = $(this).data("count");
          if ($(".next-div-" + (count - 1)).length > 0) {
            $(".next-div-" + count).removeClass("active").hide();
            $(".next-div-" + (count - 1))
              .addClass("active").show()
              .fadeIn(2000);
          }
          return false;
        }
      });
    return false;
  });
  $(".apps-next-button").click(function () {
    let parent = ".product-media-modal__content";
    $(parent)
      .find(".img-fluid")
      .each(function () {
        if ($(this).hasClass("active")) {
          let count = $(this).data("count");
          if ($(".next-div-" + (count + 1)).length > 0) {
            $(".next-div-" + count).removeClass("active").hide();
            $(".next-div-" + (count + 1))
              .addClass("active").show()
              .fadeIn(2000);
          }
          return false;
        }
      });
    return false;
  });
  $(".swipe-image").onSwipe(function (results) {
    if (results.right == true) {
      let parent = ".product-media-modal__content";
      $(parent)
        .find(".img-fluid")
        .each(function () {
          if ($(this).hasClass("active")) {
            let count = $(this).data("count");
            if ($(".next-div-" + (count - 1)).length > 0) {
              $(".next-div-" + count).removeClass("active").hide();
              $(".next-div-" + (count - 1))
                .addClass("active").show()
                .fadeIn(2000);
            }
            return false;
          }
        });
    }

    if (results.left == true) {
      let parent = ".product-media-modal__content";
      $(parent)
        .find(".img-fluid")
        .each(function () {
          if ($(this).hasClass("active")) {
            let count = $(this).data("count");
            if ($(".next-div-" + (count + 1)).length > 0) {
              $(".next-div-" + count).removeClass("active").hide();
              $(".next-div-" + (count + 1))
                .addClass("active").show()
                .fadeIn(2000);
            }
            return false;
          }
        });
    }
  });
});
